const moviesAPI = {
  'Trending': [
    {
    title: 'Uncharted',
    image: 'https://i.imgur.com/QwpThdn.jpeg',
    video: 'https://www.youtube.com/watch?v=eHp3MbsCbMg'
    },
    {
    title: 'The Batman',
    image: 'https://www.thebatman.com/images/share.jpg',
    video: 'https://www.youtube.com/watch?v=mqqft2x_Aa4'
    },
    {
    title: 'Doctor Strange: MoM',
    image: 'https://assets-prd.ignimgs.com/2022/05/08/doctor-strange-multiverse-1280-1651093649295-1652033173750.jpg',
    video: 'https://www.youtube.com/watch?v=Rf8LAYJSOL8'
    },
    {
    title: 'Spider-Man: NWH',
    image: 'https://images.indianexpress.com/2021/11/spider-man-no-way-home-new-poster-1200.jpg',
    video: 'https://www.youtube.com/watch?v=JfVOs4VSpmA'
    },
    {
    title: 'The Northman',
    image: 'https://www.indiewire.com/wp-content/uploads/2022/03/Ethan-Hawke-1-e1649689415125.jpg',
    video: 'https://www.youtube.com/watch?v=oMSdFM12hOw'
    },
    {
    title: 'The Bad Guys',
    image: 'https://variety.com/wp-content/uploads/2022/04/the-bad-guys.jpg',
    video: 'https://www.youtube.com/watch?v=CNcT9GguOOA'
    },
    {
    title: 'Fantastic Beasts: Dumbledore',
    image: 'https://images.indianexpress.com/2022/04/Fantastic-Beasts-Secrets-of-Dumbledore-review.jpg',
    video: 'https://www.youtube.com/watch?v=Y9dr2zw-TXQ'
    },
    {
    title: 'Happening',
    image: 'https://i.ytimg.com/vi/UeQLR3J4K6c/maxresdefault.jpg',
    video: 'https://www.youtube.com/watch?v=HAQVYYqj3Ro'
    },
    {
    title: 'Sonic The Hedgehog 2',
    image: 'https://ucsdguardian.org/wp-content/uploads/2022/04/sonic-courtesy-of-game-informer-752x440.jpeg',
    video: 'https://www.youtube.com/watch?v=47r8FXYZWNU'
    },
    {
    title: 'The Gentlemen',
    image: 'https://www.denofgeek.com/wp-content/uploads/2020/01/the-gentlemen-1.jpeg',
    video: 'https://www.youtube.com/watch?v=vaN8BtA8OJk'
    },],
  'Comedy': [
    {
    title: 'Stranger Than Fiction',
    image: 'https://assets.mubicdn.net/images/film/3697/image-w1280.jpg?1460061142',
    video: 'https://www.youtube.com/watch?v=51aqOv-7Vu8'
    },
    {
    title: 'Disaster Artist',
    image: 'https://static01.nyt.com/images/2017/12/01/arts/01disasterartist-web/01disasterartist-web-superJumbo.jpg',
    video: 'https://www.youtube.com/watch?v=cMKX2tE5Luk'
    },
    {
    title: 'Monty Python: Holy Grail',
    image: 'https://images.squarespace-cdn.com/content/v1/587e54ab3e00becc5a895fbf/1650408291841-1VFKT1JCJNO962E2PWTT/monty+python.jpg?format=1500w',
    video: 'https://www.youtube.com/watch?v=urRkGvhXc8w'
    },
    {
    title: 'The Incredibles',
    image: 'https://prod-ripcut-delivery.disney-plus.net/v1/variant/disney/FE15AC086E2D128FB276B15B0557CA8E6E5931513511BD6947E66759D1A00FC8/scale?width=2880&aspectRatio=1.78&format=jpeg',
    video: 'https://www.youtube.com/watch?v=sJCjKQQOqT0'
    },
    {
    title: 'Airplane! 2',
    image: 'https://images-na.ssl-images-amazon.com/images/S/pv-target-images/27a3bd05fbe38a7f3c042f43688cabb0b511f1ac7c39dc1eaab7327437aae679._UR1920,1080_RI_.jpg',
    video: 'https://www.youtube.com/watch?v=HZokeJ_n-0c'
    },
    {
    title: 'Popstar: NSNS',
    image: 'https://pbs.twimg.com/media/D34oFjwX4AAoMss.jpg:large',
    video: 'https://www.youtube.com/watch?v=Q9RoNzJrmDo'
    },
    {
    title: 'Central Intelligence',
    image: 'https://i.ytimg.com/vi/MxEw3elSJ8M/maxresdefault.jpg',
    video: 'https://www.youtube.com/watch?v=QrgXU1zHfFI'
    },
    {
    title: 'Grown Ups',
    image: 'https://media.npr.org/assets/artslife/movies/2010/06/grown-ups/rock-james-spade-sandler_wide-db9843d629490fd662531e7266b7c2322e4227f1.jpg?s=1400',
    video: 'https://www.youtube.com/watch?v=e01NVCveGkg'
    },
    {
    title: 'Just Go With It',
    image: 'https://media.npr.org/assets/img/2011/02/04/df-18707_wide-6d1efe599f05fb99fa092698742f57102213d57d-s1100-c50.jpg',
    video: 'https://www.youtube.com/watch?v=GA0zBMy6uVk'
    },
    {
    title: 'The Other Guys',
    image: 'https://i0.wp.com/www.solzyatthemovies.com/wp-content/uploads/2021/12/The-Other-Guys.jpg',
    video: 'https://www.youtube.com/watch?v=D6WOoUG1eNo'
    },],
  'Action': [
    {
    title: 'Avengers: Infinity War',
    image: 'https://www.denofgeek.com/wp-content/uploads/2019/04/infinity-war-montage-main.jpg',
    video: 'https://www.youtube.com/watch?v=6ZfuNTqbHE8'
    },
    {
    title: 'Avengers: Endgame',
    image: 'https://www.denofgeek.com/wp-content/uploads/2019/04/avengers-endgame-ending-explained.jpg',
    video: 'https://www.youtube.com/watch?v=TcMBFSGVi1c'
    },
    {
    title: 'Mad Max: Fury Road',
    image: 'https://i.ytimg.com/vi/UtjGTrVwRr4/maxresdefault.jpg',
    video: 'https://www.youtube.com/watch?v=hEJnMQG9ev8'
    },
    {
    title: 'Star Wars: Last Jedi',
    image: 'https://imageio.forbes.com/blogs-images/scottmendelson/files/2017/12/pTmvVqg.jpg',
    video: 'https://www.youtube.com/watch?v=Q0CbN8sfihY'
    },
    {
    title: 'Godzilla',
    image: 'https://www.denofgeek.com/wp-content/uploads/2021/03/Godzilla.jpg',
    video: 'https://www.youtube.com/watch?v=QFxN2oDKk0E'
    },
    {
    title: 'Transformers: Rise of Unicron',
    image: 'https://hbomax-images.warnermediacdn.com/images/GYPH_IAJTJKaVTAEAAABy/tile?size=640x360&partner=hbomaxcom&v=942d38417c064f2a6579cab3eef76048&language=en-us&host=art-gallery.api.hbo.com',
    video: 'https://www.youtube.com/watch?v=Nq25gnmvLjQ'
    },
    {
    title: 'The Dark Knight',
    image: 'https://www.denofgeek.com/wp-content/uploads/2018/07/the_dark_knight_10_year_anniversary_best_superhero_movie.jpg',
    video: 'https://www.youtube.com/watch?v=EXeTwQWrcwY'
    },
    {
    title: 'Skyfall',
    image: 'https://townsquare.media/site/295/files/2020/11/20a86206ec15a3d88a12f22ee07fef62.jpg',
    video: 'https://www.youtube.com/watch?v=6kw1UVovByw'
    },
    {
    title: 'Hurt Locker',
    image: 'https://www.moma.org/d/assets/W1siZiIsIjIwMTkvMTAvMjkvOHNvYzZlOG45a190aGVfaHVydF9sb2NrZXIuanBnIl0sWyJwIiwiY29udmVydCIsIi1xdWFsaXR5IDkwIC1yZXNpemUgMjAwMHgyMDAwXHUwMDNlIl1d/the%20hurt%20locker.jpg',
    video: 'https://www.youtube.com/watch?v=AIbFvqFYRT4'
    },
    {
    title: 'Kubo and Two Strings',
    image: 'https://www.denofgeek.com/wp-content/uploads/2016/09/kubo-main_0.jpg',
    video: 'https://www.youtube.com/watch?v=vex0gPFnBvM'
    },],
  'Rom-Com': [
    {
    title: 'The Notebook',
    image: 'https://media.vanityfair.com/photos/55ca51b48fbf768838dc8ef9/master/pass/the-notebook-tv-series.jpg',
    video: 'https://www.youtube.com/watch?v=yDJIcYE32NU'
    },
    {
    title: 'When Harry Met Sally',
    image: 'https://austin.com/wp-content/uploads/2022/02/1450277872-when-harry-met-sally-movie.jpg',
    video: 'https://www.youtube.com/watch?v=vmSpCLefjnw'
    },
    {
    title: 'Eternal Sunshine of the Spotless Mind',
    image: 'https://www.pluggedin.com/wp-content/uploads/2019/12/eternal-sunshine-of-the-spotless-mind-1024x576.jpg',
    video: 'https://www.youtube.com/watch?v=yE-f1alkq9I'
    },
    {
    title: 'Always Be My Maybe',
    image: 'https://static01.nyt.com/images/2019/05/29/arts/29Alwaysbe/29Alwaysbe-superJumbo.jpg',
    video: 'https://www.youtube.com/watch?v=iHBcWHY9lN4'
    },
    {
    title: 'Scott Pilgram vs The World',
    image: 'https://i.ytimg.com/vi/7wd5KEaOtm4/maxresdefault.jpg',
    video: 'https://www.youtube.com/watch?v=7wd5KEaOtm4'
    },
    {
    title: 'Sleepless in Seattle',
    image: 'https://www.gannett-cdn.com/-mm-/5c0ee556a3902e8d41ff5684a0075de3fc1953a9/c=0-76-1415-874/local/-/media/USATODAY/USATODAY/2014/05/20//1400614030001-SLEEPLESS-IN-SEATTLE-801197.JPG',
    video: 'https://www.youtube.com/watch?v=ahI9LaOGYcE'
    },
    {
    title: 'Princess Bride',
    image: 'https://www.hollywoodreporter.com/wp-content/uploads/2013/11/cary_elwes_robin_wright_princess_bride.jpg',
    video: 'https://www.youtube.com/watch?v=O3CIXEAjcc8'
    },
    {
    title: '50 First Dates',
    image: 'https://www.pluggedin.com/wp-content/uploads/2019/12/50-first-dates.jpg',
    video: 'https://www.youtube.com/watch?v=Q_2AbjYeSMI'
    },
    {
    title: 'Clueless',
    image: 'https://dynaimage.cdn.cnn.com/cnn/c_fill,g_auto,w_1200,h_675,ar_16:9/https%3A%2F%2Fcdn.cnn.com%2Fcnnnext%2Fdam%2Fassets%2F200815163257-clueless-movie-file-restricted.jpg',
    video: 'https://www.youtube.com/watch?v=Mgjwq1ZzdPQ'
    },
    {
    title: 'Groundhog Day',
    image: 'https://static01.nyt.com/images/2021/01/31/multimedia/31ah-groundhogday-movies/31ah-groundhogday-movies-superJumbo.jpg',
    video: 'https://www.youtube.com/watch?v=GncQtURdcE4'
    },],
  'Suspense': [
    {
    title: 'A Quiet Place',
    image: 'https://assets-prd.ignimgs.com/2021/10/26/quiet-place-1635256853250.jpg',
    video: 'https://www.youtube.com/watch?v=WR7cc5t7tv8'
    },
    {
    title: 'Alien',
    image: 'https://www.slashfilm.com/img/gallery/how-to-watch-the-alien-movies-in-order/intro-1627066084.jpg',
    video: 'https://www.youtube.com/watch?v=jQ5lPt9edzQ'
    },
    {
    title: 'Jaws',
    image: 'https://i.guim.co.uk/img/static/sys-images/Guardian/Pix/pictures/2015/5/27/1432747084178/The-classic-poster-image--009.jpg?width=465&quality=45&auto=format&fit=max&dpr=2&s=ffabefb662ce8540d3c428f9658b55fe',
    video: 'https://www.youtube.com/watch?v=U1fu_sA7XhE'
    },
    {
    title: 'Babadook',
    image: 'https://www.rollingstone.com/wp-content/uploads/2018/06/rs-the-babadook-9ec1c549-fa03-4109-815f-83a157445522.jpg',
    video: 'https://www.youtube.com/watch?v=k5WQZzDRVtw'
    },
    {
    title: 'Sicario',
    image: 'https://hollywoodsuite.ca/wp-content/uploads/poster/HS904041_poster_1920_1080.JPG',
    video: 'https://www.youtube.com/watch?v=G8tlEcnrGnU'
    },
    {
    title: 'Black Swan',
    image: 'https://media.newyorker.com/photos/590969441c7a8e33fb38db50/master/pass/101206_r20291_p886.jpg',
    video: 'https://www.youtube.com/watch?v=5jaI1XOB-bs'
    },
    {
    title: 'Sixth Sense',
    image: 'https://m.media-amazon.com/images/M/MV5BMTk0MzcwNjMxN15BMl5BanBnXkFtZTcwMjYyODY3Mw@@._V1_.jpg',
    video: 'https://www.youtube.com/watch?v=3-ZP95NF_Wk'
    },
    {
    title: 'Reservoir Dogs',
    image: 'https://cdn.mos.cms.futurecdn.net/29PdrBmsXor4raqYFS7Vb3.jpg',
    video: 'https://www.youtube.com/watch?v=vayksn4Y93A'
    },
    {
    title: 'Seven',
    image: 'https://thespool.net/wp-content/uploads/2020/09/se7en-2.jpg',
    video: 'https://www.youtube.com/watch?v=znmZoVkCjpI'
    },
    {
    title: 'Pulp Fiction',
    image: 'https://www.indiewire.com/wp-content/uploads/2019/07/Screen-Shot-2019-07-22-at-5.09.08-PM.png',
    video: 'https://www.youtube.com/watch?v=tGpTpVyI_OQ'
    },]
}

export default moviesAPI
